<template>
  <div>
    <div class="create-user-form">
      <div class="create-user-form-steps-desktop">
        <el-steps :active="currentStep" finish-status="success">
          <el-step :title="stepLabel[0]"></el-step>
          <el-step :title="stepLabel[1]"></el-step>
          <el-step :title="stepLabel[2]"></el-step>
          <el-step :title="stepLabel[3]"></el-step>
        </el-steps>
      </div>
      <div class="create-user-form-steps-mobile">
        <div class="create-user-form-steps-mobile__container">
          <div
            v-if="currentStep > 0"
            class="create-user-form-steps-mobile__step create-user-form-steps-mobile__step--first"
          >
            <div :class="['create-user-form-steps-mobile__step-number']">
              <i class="el-step__icon-inner is-status el-icon-check"></i>
            </div>
            <div
              :class="['create-user-form-steps-mobile__step-label']"
            >{{ stepLabel[currentStep - 1]}}</div>
          </div>
          <div
            class="create-user-form-steps-mobile__step create-user-form-steps-mobile__step--curent"
          >
            <div class="create-user-form-steps-mobile__step-number">
              <span>{{ currentStep + 1}}</span>
            </div>
            <div class="create-user-form-steps-mobile__step-label">{{ stepLabel[currentStep]}}</div>
          </div>
          <div
            v-if="currentStep < 4"
            class="create-user-form-steps-mobile__step create-user-form-steps-mobile__step--last"
          >
            <div :class="['create-user-form-steps-mobile__step-number']">
              <span>{{ currentStep + 2}}</span>
            </div>
            <div
              :class="['create-user-form-steps-mobile__step-label']"
            >{{ stepLabel[currentStep + 1]}}</div>
          </div>
          <div
            v-bind:class="{ hide: currentStep == 0 }"
            class="create-user-form-steps-mobile__line create-user-form-steps-mobile__line--left"
          ></div>
          <div
            v-bind:class="{ hide: currentStep == 4 }"
            class="create-user-form-steps-mobile__line create-user-form-steps-mobile__line--right"
          ></div>
        </div>
      </div>
      <div class="create-user-form-content">
        <first-step @setPageTitle="setPageTitle" v-show="currentStep == 0" ref="firstStep"></first-step>
        <second-step v-show="currentStep == 1" ref="secondStep"></second-step>
        <third-step v-show="currentStep == 2" ref="thirdStep"></third-step>
        <div v-if="currentStep == 3" v-loading="loading">
          <div class="row">
            <div class="col-md-4">
              <div class="create-user-form-finish__title">{{ $t('labels.check_data_is_correct') }}</div>
              <div class="create-user-form-finish__data">
                <div v-if="userpic.preview" class="create-user-form-finish__avatar">
                  <img :src="userpic.preview" :alt="$t('labels.photo')" />
                </div>
                <div class="create-user-form-finish__data-row">
                  <template v-if="userData.login">
                    <div class="create-user-form-finish__data-label">{{ $t('labels.login') }}</div>
                    <div class="create-user-form-finish__data-content">{{ userData.login }}</div>
                  </template>
                  <template v-if="userData.email">
                    <div class="create-user-form-finish__data-label">{{ $t('labels.email') }}</div>
                    <div class="create-user-form-finish__data-content">{{ userData.email }}</div>
                  </template>
                  <div class="create-user-form-finish__data-label">{{ $t('labels.phone') }}</div>
                  <div class="create-user-form-finish__data-content">{{ userData.phone }}</div>
                </div>
                <div class="create-user-form-finish__data-row">
                  <div class="create-user-form-finish__data-label">{{ $t('labels.surname') }}:</div>
                  <div class="create-user-form-finish__data-content">{{ userData.last_name }}</div>
                  <div class="create-user-form-finish__data-label">{{ $t('labels.name') }}:</div>
                  <div class="create-user-form-finish__data-content">{{ userData.first_name }}</div>
                  <div class="create-user-form-finish__data-label">{{ $t('labels.middle_name') }}:</div>
                  <div class="create-user-form-finish__data-content">{{ userData.middle_name }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-8">
              <div class="create-user-form-finish">
                <div
                  class="create-user-form-finish__data-workplaces"
                  v-for="(place, index) in userData.orgs"
                  :key="index"
                >
                  <div class="create-user-form-finish__data-workplaces-title">
                    {{ $t('labels.work_place') }}
                    <span v-if="orgs.length > 1">{{ index + 1}}</span>
                  </div>
                  <div class="create-user-form-finish__data-workplaces-row">
                    <div class="create-user-form-finish__data-workplaces-label">{{ $t('labels.place') }}:</div>
                    <div class="create-user-form-finish__data-workplaces-content">
                      <dep-name :orgId="place.org_id" :showParent="true"></dep-name>
                    </div>
                  </div>
                  <div class="create-user-form-finish__data-workplaces-row">
                    <div class="create-user-form-finish__data-workplaces-label">{{ $t('labels.position') }}:</div>
                    <div class="create-user-form-finish__data-workplaces-content">{{place.note}}</div>
                  </div>
                </div>
                <div class="create-user-form-finish__specialty">
                  <div class="create-user-form-finish__specialty-title">{{ $t('labels.permitted_actions') }}</div>
                  <roles-to-text :roles="userData.roles"></roles-to-text>
                </div>
                <div v-if="userData.note" class="create-user-form-finish__regalia">
                  <div class="create-user-form-finish__regalia-title">{{ $t('labels.note') }}</div>
                  <div class="create-user-form-finish__regalia-text">{{ userData.note }}</div>
                </div>
                <div v-if="userData.contacts.length" class="create-user-form-finish__contacts">
                  <div class="create-user-form-finish__contacts-title">{{ $t('labels.contacts') }}</div>
                  <div
                    v-for="(contact, index) in userData.contacts"
                    :key="index"
                    class="create-user-form-finish__contacts-row"
                  >
                    <div class="create-user-form-finish__contacts-row-label">{{contact.type}}</div>
                    <div class="create-user-form-finish__contacts-row-data">{{ contact.value }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="create-user-form-buttons">
        <el-button v-if="currentStep >= 1" style="margin-top: 12px;" @click="prev">{{ $t('labels.prev') }}</el-button>
        <el-button v-if="currentStep == 2" style="margin-top: 12px;" @click="next">
          {{ $t('labels.skip') }}
          <i class="el-icon-arrow-right el-icon-right"></i>
        </el-button>
        <el-button
          v-if="currentStep <= 2"
          style="margin-top: 12px;"
          @click="next(), loadData()"
          type="primary"
        >
          {{ $t('labels.add_employee') }}
          <i class="el-icon-arrow-right el-icon-right"></i>
        </el-button>
        <el-button v-else style="margin-top: 12px;" @click="complete" type="primary">{{ $t('labels.end') }}</el-button>
      </div>
    </div>
  </div>
</template>
<script>
  import firstStep from './steps/firstStep.vue'
  import secondStep from './steps/secondStep.vue'
  import thirdStep from './steps/thirdStep.vue'
  import RolesToText from '@/components/Users/RolesToText.vue'
  import depName from 'src/components/Orgs/OrgName.vue'
  // import specialtyInRow from 'src/components/SpecialtyInRow/SpecialtyInRow.vue'
  import _ from 'lodash'
  export default {
    components: {
      firstStep,
      secondStep,
      thirdStep,
      RolesToText,
      depName
    },
    data () {
      return {
        userData: {},
        orgs: [],
        userpic: {
          blob: null,
          preview: null
        },
        loading: false,
        currentStep: 0,
        stepLabel: [
          this.$t('employees.steps.step1'),
          this.$t('employees.steps.step2'),
          this.$t('employees.steps.step3'),
          this.$t('employees.steps.step4')
        ]
      }
    },
    methods: {
      next () {
        let component = this.currentStepComponent(this.currentStep)
        let isStepValid = this.$refs[component].isStepValid()
        if (isStepValid) {
          if (++this.currentStep > 3) this.currentStep = 0;
        }
        this.$root.$emit('resetScroll')
      },
      prev () {
        if (--this.currentStep < 0) this.currentStep = 0;
        this.$root.$emit('resetScroll')
      },
      setPageTitle () {
        this.$emit('setPageTitle', this.passport)
      },
      resetPageTitle () {
        this.$emit('resetPageTitle')
      },
      async complete () {
        console.log('[USER CREATE]', this.userData);
        try {
          this.loading = true;
          let response = await this.$store.dispatch('users/createUser', this.userData)
          console.log('LOG: complete -> response', response)
          if (this.userpic.blob) {
            await this.$store.dispatch('users/setUpic', {upic: this.userpic.blob, userId: response.user_id})
          }
          this.loading = false;
          this.formReset();
          this.currentStep = 0;
          this.resetPageTitle()
          this.$root.$emit('resetScroll')
          this.$store.commit('saveGuard/setStatus', false)
          this.$notify({
            // @ts-ignore
            title: this.$t('labels.success'),
            // @ts-ignore
            message: this.$t('employees.created'),
            type: 'success',
            offset: 75
          })
        } catch (error) {
          this.loading = false;
          this.$notify({
            // @ts-ignore
            title: this.$t('labels.error'),
            // @ts-ignore
            message: this.$t('employees.creating_error'),
            type: 'error',
            offset: 75
          })
          console.error('ERROR', error);
        }
      },
      formReset () {
        this.$refs.firstStep.formReset();
        this.$refs.secondStep.formReset();
        this.$refs.thirdStep.formReset();
      },
      loadData () {
        let firstStepData = this.$refs.firstStep.getData();
        let secondStepData = this.$refs.secondStep.getData();
        let thirdStepData = this.$refs.thirdStep.getData();
        this.userData = {
          ...firstStepData,
          ...secondStepData,
          ...thirdStepData
        }
        this.userpic = {
          ...this.$refs.thirdStep.userpic
        }
        this.setPageTitle()
      },
      currentStepComponent (currentStep) {
        if (currentStep === 0) {
          return 'firstStep';
        } else if (currentStep === 1) {
          return 'secondStep';
        } else if (currentStep === 2) {
          return 'thirdStep';
        }
      }
    }
  }
</script>
<style lang="scss">
  @import 'src/assets/sass/core';
  $screen-sm: 768px;
  $screen-md: 992px;
  $screen-lg: 1200px;
  $max-container-width: $screen-lg;

  .create-user-form {
    padding: 0;
    border-radius: $global-radius;
    overflow: hidden;
    transform: translate3d(0px, 0, 0);

    &__section {
      margin-bottom: 40px;
      overflow-x: auto;
      .el-input,
      .el-textarea {
        margin-bottom: 30px;
      }
      .Password__field {
        margin-bottom: 0;
      }
    }

    &__section-title {
      font-size: 24px;
      margin-bottom: 20px;
    }

    &__section-error {
      color: #ff5151;
      font-weight: 700;
      font-size: 12px;
    }

    .el-select {
      min-width: 300px;

      @media (max-width: $screen-sm) {
        min-width: auto;
        width: 100%;
      }
    }

    .el-button {
      margin-right: 10px;
    }

    .el-button + .el-button {
      margin-left: 0;
    }
  }

  .el-step {
    &.disable {
      .el-step__icon {
        color: #ececec;
        border-color: #ececec;
      }
      .el-step__title {
        color: #ececec;
      }
    }
  }

  /*  Label input */
  .create-user-form {
    .el-input--prefix .el-input__inner {
      position: relative;
      z-index: 1;
      padding-left: 15px;
    }

    /* Label */
    .el-input__prefix {
      left: 5px;
      top: -18px;
      font-size: 12px;
      opacity: 0;
      visibility: hidden;
      z-index: 0;
    }

    .el-input__suffix {
      z-index: 2;
    }

    .el-select__tags {
      z-index: 2;
    }

    .el-input,
    .el-select,
    .el-textarea {
      &.showLabel {
        .el-input__prefix {
          animation-name: showLabel;
          animation-duration: 0.5s;
          animation-direction: normal;
          animation-fill-mode: forwards;
          animation-timing-function: cubic-bezier(0.77, 0, 0.175, 1);
        }
      }
    }

    @keyframes showLabel {
      0% {
        visibility: visible;
        opacity: 0;
        transform: translateX(50px);
      }
      100% {
        visibility: visible;
        opacity: 1;
        transform: translateX(0);
      }
    }
  }

  /* Erors */
  .el-input,
  .el-select {
    &.error {
      .el-input__inner {
        border-color: #ff5151;
        position: relative;
        z-index: 1;
      }

      .label-error {
        color: #ff5151;
      }
    }
  }

  .create-user-form-steps-desktop {
    background: #fff;
    padding: 40px 25px;

    @media only screen and (max-width: $screen-sm) {
      display: none;
    }

    .el-step__title {
      max-width: 150px;
      line-height: 1.3;
      margin-right: 5px;

      @media only screen and (max-width: $screen-sm) {
        font-size: 12px;
      }
    }
  }

  .create-user-form-steps-mobile {
    margin: 0;
    overflow: hidden;
    background: #fff;
    padding: 40px 0;

    &__container {
      position: relative;
      height: 130px;

      &:before,
      &:after {
        content: '';
        position: absolute;
        z-index: 2;
        top: 0;
        width: 50px;
        height: 100%;
      }

      &:before {
        left: 0;
        background: linear-gradient(
          to right,
          #fff,
          rgba(255, 255, 255, 0.9),
          rgba(255, 255, 255, 0.8),
          rgba(255, 255, 255, 0.7),
          rgba(255, 255, 255, 0.6),
          rgba(255, 255, 255, 0.5),
          rgba(255, 255, 255, 0.4),
          rgba(255, 255, 255, 0.3),
          rgba(255, 255, 255, 0.2),
          rgba(255, 255, 255, 0.1),
          rgba(255, 255, 255, 0)
        );
      }

      &:after {
        right: 0;
        background: linear-gradient(
          to left,
          #fff,
          rgba(255, 255, 255, 0.9),
          rgba(255, 255, 255, 0.8),
          rgba(255, 255, 255, 0.7),
          rgba(255, 255, 255, 0.6),
          rgba(255, 255, 255, 0.5),
          rgba(255, 255, 255, 0.4),
          rgba(255, 255, 255, 0.3),
          rgba(255, 255, 255, 0.2),
          rgba(255, 255, 255, 0.1),
          rgba(255, 255, 255, 0)
        );
      }
    }

    &__step {
      position: absolute;
      z-index: 1;
      top: 0;
      width: 100px;
      text-align: center;

      &--first {
        left: 0;
        color: #67c23a;
      }

      &--curent {
        font-weight: 700;
        left: 50%;
        transform: translateX(-50%);
      }

      &--last {
        right: 0;
      }
    }

    &__step-number {
      position: relative;
      z-index: 1;
      display: inline-block;
      line-height: 21px;
      width: 24px;
      height: 24px;
      margin: 0 auto;
      border: 2px solid;
      text-align: center;
      border-radius: 100%;
      font-size: 14px;
      font-weight: 700;
      background: #fff;

      &.disable {
        color: #ececec;
      }
    }

    &__line {
      position: absolute;
      z-index: 0;
      top: 13px;
      height: 2px;
      width: 50%;
      background: #000;

      &--left {
        left: 0;
        background: #67c23a;
      }

      &--right {
        right: 0;
      }

      &.hide {
        display: none;
      }
    }

    &__step-label {
      margin-top: 10px;
      font-size: 12px;

      &.disable {
        color: #ececec;
      }
    }

    @media only screen and (min-width: $screen-sm) {
      display: none;
    }
  }

  .create-user-form-content {
    background: #fff;
    padding: 0 25px;
    &--services {
      margin-top: 20px;
      + .create-user-form-buttons {
        padding-top: 28px;
      }
    }
  }

  .create-user-form-buttons {
    background: #fff;
    padding: 0 25px 40px;
  }

  .el-select-dropdown {
    .level-1,
    .level-2,
    .level-3 {
      display: inline-block;
    }

    .level-2 {
      padding-left: 10px;
      font-size: 14px;
    }

    .level-3 {
      padding-left: 20px;
      font-size: 12px;
    }

    .level-4 {
      padding-left: 30px;
      font-size: 12px;
    }

    .level-5 {
      padding-left: 40px;
      font-size: 12px;
    }

    .level-6 {
      padding-left: 50px;
      font-size: 12px;
    }

    .level-7 {
      padding-left: 60px;
      font-size: 12px;
    }
  }

  .create-user-form-workplaces {
    margin-bottom: 40px;

    &__section {
      margin-bottom: 8px;
      border-bottom: 1px solid #dcdfe6;
    }

    &__item {
      margin-bottom: 20px;
    }

    &__tree {
      &.error {
        .tree-select__input {
          border-color: #ff5151;
        }
      }
    }

    .services-tree-select {
      margin-bottom: 20px;
    }

    &__title {
      font-size: 24px;
      margin-bottom: 20px;
    }

    &__add {
      color: #2196f3;
      cursor: pointer;

      &:hover {
        color: lighten(#2196f3, 15%);
      }
    }

    &__roles {
      margin-bottom: 30px;

      .el-input {
        margin-bottom: 0;
      }
    }

    &__reception {
      margin-bottom: 15px;
    }

    &__posts {
      margin-bottom: 30px;

      .el-input {
        margin-bottom: 0;
      }
      .el-tag {
        height: auto;
        white-space: normal;
        word-break: break-all;
      }
    }

    &__delete-role {
      position: relative;
      z-index: 1;
      margin-top: -25px;
      margin-bottom: 15px;
      font-size: 12px;
      color: #2196f3;
      cursor: pointer;

      &:hover {
        color: lighten(#2196f3, 15%);
      }
    }

    &__delete {
      margin-bottom: 25px;
      margin-top: -20px;
      span {
        font-size: 12px;
        color: #2196f3;
        cursor: pointer;

        &:hover {
          color: lighten(#2196f3, 15%);
        }
      }
    }
  }

  .create-user-form-show-password {
    height: 100%;
    width: 25px;
    text-align: center;
    transition: all 0.3s;
    line-height: 40px;
    cursor: pointer;

    &:hover {
      color: #000;
    }
  }

  .create-user-form-superuser-switch {
    margin-bottom: 25px;
    color: #a2a2a2;
    display: grid;
    grid-template-columns: 45px 1fr;
    grid-column-gap: 10px;

    &.active {
      color: #3e3e3e;
    }

    &__text {
      cursor: pointer;
    }
  }

  .create-user-form-send-to-email {
    .el-checkbox__input {
      vertical-align: top;
    }
  }

  .create-user-form-finish {
    margin-bottom: 30px;

    &__title {
      font-size: 24px;
      margin-bottom: 26px;
    }

    &__data-row {
      display: grid;
      grid-template-columns: 150px 1fr;
      padding: 10px 0;
      border-top: 1px solid #cecece;
      word-break: break-all;
      &:last-child {
        border-bottom: 1px solid #cecece;
      }
      @include respond-to(phone) {
        grid-template-columns: 1fr;
      }
    }

    &__data-label,
    &__data-content {
      padding: 5px 0;
    }

    &__data-label,
    &__data-workplaces-label {
      word-break: normal;
      font-weight: 600;
    }

    &__avatar {
      width: 180px;
      margin-bottom: 25px;

      img {
        width: 100%;
        border-radius: 100%;
      }
    }

    &__data-workplaces {
      padding: 10px 0;
    }

    &__data-workplaces-title {
      font-size: 20px;
      margin-bottom: 12px;
    }

    &__data-workplaces-row {
      display: grid;
      grid-template-columns: 200px 1fr;
      grid-column-gap: 20px;
      padding: 5px 0;
      @include respond-to(phone) {
        grid-template-columns: 1fr;
        grid-row-gap: 10px;
        padding: 10px 0;
      }
    }

    &__specialty {
      padding: 10px 0;
      // border-top: 1px solid #cecece;
    }

    &__specialty-title {
      font-size: 20px;
      margin-bottom: 12px;
    }

    &__specialty-list {
      padding-left: 0;
      list-style-type: none;

      li {
        display: inline-block;
        margin-right: 5px;
      }
    }

    &__services {
      padding: 10px 0;
      border-top: 1px solid #cecece;
      overflow-x: auto;
    }

    &__services-title {
      font-size: 20px;
      margin-bottom: 12px;
    }

    &__services-list {
      min-width: 400px;
    }

    &__services-row {
      display: grid;
      grid-template-columns: 1fr 150px 150px;
      padding: 10px 5px;
      border-top: 1px solid #e4e4e4;
      grid-gap: 5%;
      @include respond-to(phone) {
        grid-template-columns: 1fr 1fr 1fr;
      }
    }
    &__services-vendor_code {
      padding: 0 10px;
    }

    &__regalia {
      padding: 10px 0;
      border-top: 1px solid #cecece;
    }

    &__regalia-title {
      font-size: 20px;
      margin-bottom: 12px;
    }

    &__regalia-text {
      white-space: pre-line;
    }

    &__contacts {
      padding: 10px 0;
      border-top: 1px solid #cecece;
    }

    &__contacts-title {
      font-size: 20px;
      margin-bottom: 12px;
    }

    &__contacts-row {
      display: grid;
      grid-template-columns: 150px 1fr;
      padding: 5px 0;
      @include respond-to(phone) {
        grid-template-columns: 1fr;
      }
    }

    &__contacts-row-label {
      font-weight: 600;
    }

    &__contacts-row-undefined {
      font-style: italic;
    }

    &__data-contacts-label {
      &.bold {
        font-weight: 600;
      }
    }
  }
</style>
